(() => {
  const url = new URL(location.href);
  const raw = url.searchParams.get('q') || '';
  const related = url.searchParams.get('yv_search') === 'related';
  const isContext = key => !/^(?:q$|page$|sort_by$|filter\.|options\[)/.test(key);
  const quoted = /^(?:"(?:[^"\\]|\\.)*"\s*)+$/u;
  const advanced = /[:"()*]|\b(?:AND|OR|NOT)\b/u;
  const precise = value => value.trim().split(/\s+/u).filter(Boolean).map(word => '"' + word.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"').join(' ');
  if (raw.trim() && !related && !advanced.test(raw)) {
    url.searchParams.set('q', precise(raw));
    url.searchParams.set('options[prefix]', 'none');
    location.replace(url.href);
    return;
  }
  const display = quoted.test(raw) ? Array.from(raw.matchAll(/"((?:[^"\\]|\\.)*)"/gu), match => match[1].replace(/\\(["\\])/g, '$1')).join(' ') : raw;
  const panel = document.querySelector('[data-yv-search-mode]');
  if (panel) {
    panel.hidden = !raw.trim();
    panel.querySelector('[data-yv-search-note]').textContent = related ? panel.dataset.relatedNote : panel.dataset.exactNote;
    const alternate = new URL(url);
    alternate.searchParams.set('q', display);
    alternate.searchParams.delete('page');
    if (related) alternate.searchParams.delete('yv_search');
    else alternate.searchParams.set('yv_search', 'related');
    const link = panel.querySelector('a');
    link.href = alternate.href;
    link.textContent = related ? panel.dataset.exactLabel : panel.dataset.relatedLabel;
  }
  document.querySelectorAll('form[role="search"]').forEach(form => {
    const input = form.querySelector('[name="q"]');
    if (!input) return;
    if (input.value === raw) input.value = display;
    form.addEventListener('submit', () => {
      const value = input.value.trim();
      if (!related && value && !advanced.test(value)) input.value = precise(value);
      const prefix = form.querySelector('[name="options[prefix]"]');
      if (!related && prefix) prefix.value = 'none';
      for (const [key, value] of url.searchParams) {
        if (isContext(key) && !form.elements.namedItem(key)) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = key; hidden.value = value; form.append(hidden);
        }
      }
    });
  });
  const carried = Array.from(url.searchParams).filter(([key]) => isContext(key));
  const retainContext = () => {
    document.querySelectorAll('facet-filters-form form').forEach(form => {
      for (const [key, value] of carried) {
        if (form.elements.namedItem(key)) continue;
        const hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = key; hidden.value = value; form.append(hidden);
      }
    });
    document.querySelectorAll('.pagination a[href], facet-remove a[href]').forEach(link => {
      const target = new URL(link.href);
      let changed = false;
      for (const [key, value] of carried) if (!target.searchParams.has(key)) { target.searchParams.append(key, value); changed = true; }
      if (changed) link.href = target.href;
    });
  };
  retainContext();
  new MutationObserver(retainContext).observe(document.querySelector('main'), {childList:true, subtree:true});
})();

class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

